import Ajax from '@/lib/ajax'

export default {
  /**
   * 根据KEY获取配置 
   */
    getConfig( key: string) {
      return Ajax.get(`/api/MallConfigManagement/MallConfig/${key}`)
    },
     /**
   * 新增或更改配置
   * @param key 
   * @param displayName 
   * @param value 
   */
    updateConfig(key: string, displayName: string, value: any) {
      return Ajax.put(`/api/MallConfigManagement/MallConfig`, {
        key: key,
        displayName: displayName,
        value: value
      })
    }
}